export const AvatarTheme = {
	name: 'AVATAR',
  goal: {
    "MUSCLE GAIN": "Muscle Gain",
    "FAT LOSS": "Weight Loss",
    "REVERSE DIETING": "Reverse Dieting",
    "MAINTENANCE": "Maintenance",
  },
  color: {
    primary: "#0ab23b",
    secondary: "#0ab23b",
    primaryGradient: "linear-gradient(#00eb45,#0ea039)",
		logoBackground: "#070d2c",
    dark: "#070d2c",
    green: "#00ee46",
    highlight: "#242943",
  },
  font: {
    primary: "DM Sans, sans-serif",
    secondary: "DM Sans, sans-serif",
  },
  chat: {
    headerBackground: "linear-gradient(#070d2c 30%,#06010d)",
  },
  button: {
    background: "linear-gradient(#00eb45,#0ea039)",
    color: "#FFF",
    borderRadius: "100px",
  },
  input: {
    background: "#eaedf5",
    borderRadius: "100px",
  },
  tracker: {
    background: 'linear-gradient(#070d2c, #060103)',
  }
};
